"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment_1 = require("moment");
function apiBookData(state, getters, _rootState, rootGetters) {
    var estimatedTotalPrice = getters['totalPrice'];
    var priceModel = getters['general/cruise'].priceModel;
    var agencyId = rootGetters['booking/affiliate/agencyId'] === null
        ? priceModel === 'PAUSCHAL'
            ? '37020'
            : '30449'
        : rootGetters['booking/affiliate/agencyId'];
    var confirmations = {
        newsletterAccepted: false,
        bookingConditionsAccepted: false,
        privacyPolicyAccepted: false,
        tradingConditionsAccepted: getters['checkout/terms'],
        privacyPolicyExtendedAccepted: getters['checkout/ippAccepted'] === '0' ? false : true,
    };
    var paxe = gatherPaxData(state, getters);
    var services = gatherServices(state, getters);
    var trackingId = gatherTrackingId(state, getters);
    var midofficeReference = rootGetters['booking/affiliate/midofficeReference'];
    var affiliate = {
        agencyId: agencyId
    };
    if (midofficeReference !== null) {
        affiliate.midofficeReference = midofficeReference;
    }
    return {
        paxe: paxe,
        services: services,
        estimatedTotalPrice: estimatedTotalPrice,
        priceModel: priceModel,
        confirmations: confirmations,
        affiliate: affiliate,
        sessionToken: trackingId,
    };
}
exports.apiBookData = apiBookData;
// gather pax data of all cabins in basket
function gatherPaxData(state, getters) {
    var paxes = [];
    var idx = 0;
    for (var _i = 0, _a = state.basket; _i < _a.length; _i++) {
        var cabin = _a[_i];
        var cabinPaxe = lodash_1.map(getters[cabin + '/pax/all'], function (pax) {
            var p = {
                ageGroup: undefined,
                age: undefined,
                isPrimaryPax: undefined,
                // bahnCard: undefined,
                erpId: undefined,
                id: ++idx,
                city: undefined,
                countryCode: undefined,
                nationalityCode: undefined,
                street: undefined,
                zipCode: undefined,
                email: undefined,
                phone: undefined,
            };
            var keyList = [
                'sex',
                'firstName',
                'lastName',
                'birthday',
                'nationalityCode',
            ];
            for (var _i = 0, keyList_1 = keyList; _i < keyList_1.length; _i++) {
                var key = keyList_1[_i];
                if (pax[key].type === 'number') {
                    p[key] = parseInt(pax[key].value, 10);
                }
                else {
                    p[key] = pax[key].value;
                }
            }
            p.ageGroup = 'C';
            p.age = calcAge(p['birthday'], getters['general/cruise'].departure);
            if (p.age > 15)
                p.ageGroup = 'J';
            if (p.age > 24)
                p.ageGroup = 'A';
            // p.bahnCard =
            //  getters[cabin + '/transportRail/transport'].paxWithDiscount[index]
            p.isPrimaryPax = false;
            p.erpId = pax['erpInfos'][0].erpId;
            return p;
        });
        paxes = lodash_1.concat(paxes, cabinPaxe);
    }
    var countries = getters['general/countries'];
    var postalCountryCode = getters['checkout/allFields'].postalCountryCode.value;
    var countryCode = getters['checkout/allFields'].countryCode.value;
    var intPrefix = countryCode ? countries[countryCode].phone : '';
    var phonePrefix = getters['checkout/allFields'].prefix.value.replace(/^0+/, '');
    var phone = getters['checkout/allFields'].phone.value.replace(/^0+/, '');
    paxes[getters['checkout/primaryPaxId']].isBuyer = true;
    paxes[getters['checkout/primaryPaxId']].city =
        getters['checkout/allFields'].city.value;
    paxes[getters['checkout/primaryPaxId']].postalCountryCode = postalCountryCode;
    paxes[getters['checkout/primaryPaxId']].countryCode = countryCode;
    paxes[getters['checkout/primaryPaxId']].street =
        getters['checkout/allFields'].address.value;
    paxes[getters['checkout/primaryPaxId']].zipCode =
        getters['checkout/allFields'].zipCode.value;
    paxes[getters['checkout/primaryPaxId']].email =
        getters['checkout/allFields'].email.value;
    paxes[getters['checkout/primaryPaxId']].phone = intPrefix + "-" + phonePrefix + "-" + phone;
    return paxes;
}
function gatherServices(state, getters) {
    var paxIds = [];
    var services = [];
    var currentPaxCabinSeperator = 1;
    for (var _i = 0, _a = state.basket; _i < _a.length; _i++) {
        var cabin = _a[_i];
        var transportType = getters[cabin + '/transport/getType'];
        var servicePaxes = [];
        // pax logic
        var numberPaxes = getters[cabin + '/pax/all'].length;
        servicePaxes = lodash_1.range(currentPaxCabinSeperator, numberPaxes + currentPaxCabinSeperator);
        currentPaxCabinSeperator = numberPaxes + currentPaxCabinSeperator;
        var transportServices = [];
        if (transportType === 'flight' || transportType === 'flex') {
            var serviceFlights = gatherAirService(cabin, getters);
            transportServices = serviceFlights;
            var transportations = transportType === 'flight' ? getters[cabin + '/transportAir/rnfTransportations'] :
                getters[cabin + '/transportFlexFlights/rnfTransportations'];
            for (var _b = 0, transportations_1 = transportations; _b < transportations_1.length; _b++) {
                var singleTransportation = transportations_1[_b];
                var serviceRnf = gatherRnfRailService(singleTransportation);
                transportServices.push(serviceRnf);
            }
        }
        else if (transportType === 'rail') {
            var serviceRail = gatherRailService(cabin, getters);
            transportServices.push(serviceRail);
        }
        for (var _c = 0, transportServices_1 = transportServices; _c < transportServices_1.length; _c++) {
            var service = transportServices_1[_c];
            service.paxIds = servicePaxes;
        }
        services = lodash_1.concat(services, transportServices);
        // insurance
        if (getters[cabin + '/insurance/selection'] &&
            getters[cabin + '/insurance/selection'] !== 'NONE') {
            var insuranceService = {
                code: getters[cabin + '/insurance/selection'],
                paxIds: servicePaxes,
                price: getters[cabin + '/insurance/totalPrice'] || 0,
                type: 'INS',
            };
            services.push(insuranceService);
        }
        // cruise
        var cruiseService = {
            cabinCategory: getters[cabin + '/cabins/selectedCabinCategoryCode'],
            cabinNumber: getters[cabin + '/cabins/currentSelectionCabinNumber'],
            id: getters['general/cruise'].id,
            price: getters[cabin + '/cabins/selectedCabinCategoryPrice'] || 0,
            paxIds: servicePaxes,
            type: 'CRU',
        };
        services.push(cruiseService);
    }
    return services;
}
function gatherAirService(cabin, getters) {
    var serviceFlights = [];
    var bookingData = [];
    /* if (getters[cabin + '/transport/getType'] === 'flight' &&
        getters[cabin + '/transport/getSubType'] === 'flex') {
      bookingData = getters[cabin + '/transportFlexFlights/transportOptionsForBooking']
    } else {
      bookingData = getters[cabin + '/transportAir/transportOptionsForBooking']
    } */
    if (getters[cabin + '/transport/getType'] === 'flex') {
        bookingData =
            getters[cabin + '/transportFlexFlights/transportOptionsForBooking'];
    }
    else if (getters[cabin + '/transport/getType'] === 'flight') {
        bookingData = getters[cabin + '/transportAir/transportOptionsForBooking'];
    }
    for (var _i = 0, bookingData_1 = bookingData; _i < bookingData_1.length; _i++) {
        var flightData = bookingData_1[_i];
        var serviceFlight = {
            category: flightData.category,
            code: flightData.code,
            direction: flightData.direction,
            type: flightData.type,
            paxIds: [],
            price: flightData.price,
        };
        serviceFlights.push(serviceFlight);
    }
    return serviceFlights;
}
function gatherRailService(cabin, getters) {
    var serviceRail = {
        type: 'RIT',
        category: undefined,
        code: undefined,
        direction: undefined,
        endDate: undefined,
        startDate: undefined,
        price: getters[cabin + '/transportRail/totalPrice'],
        paxIds: [],
    };
    var railTransport = getters[cabin + '/transportRail/transport'];
    if (railTransport.departure) {
        serviceRail.category = railTransport.departureConfig.category;
        serviceRail.code = railTransport.code;
        // serviceRail.startDate = railTransport.departureConfig.date
    }
    if (railTransport.arrival) {
        serviceRail.category = railTransport.arrivalConfig.category;
        serviceRail.code = railTransport.code;
        // serviceRail.endDate = railTransport.arrivalConfig.date
    }
    serviceRail.direction = lodash_1.find(railTransport.transportations, function (trans) {
        return trans.tariffType === railTransport.selectedTariffType;
    }).direction;
    return serviceRail;
}
function gatherRnfRailService(data) {
    var serviceRail = {
        type: 'RNF',
        category: data.transportationClass,
        code: data.code,
        direction: data.direction,
        endDate: undefined,
        startDate: undefined,
        price: data.referencePrice,
        paxIds: [],
    };
    return serviceRail;
}
function gatherTrackingId(state, getters) {
    if (state.basket.length === 1) {
        /* if (getters[state.activeCabinKey + '/transport/getType'] === 'flight' &&
            getters[state.activeCabinKey + '/transport/getSubType'] === 'flex') {
          return getters[state.activeCabinKey + '/transportFlexFlights/trackingId']
        } */
        if (getters[state.activeCabinKey + '/transport/getType'] === 'flex') {
            return getters[state.activeCabinKey + '/transportFlexFlights/trackingId'];
        }
    }
    return null;
}
function calcAge(birthday, cruiseDeparture) {
    var bd = moment_1.utc(birthday, 'DD.MM.YYYY');
    var cd = moment_1.utc(cruiseDeparture, 'DD.MM.YYYY');
    return cd.diff(bd, 'years');
}
//# sourceMappingURL=apiBookData.js.map